"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCreateBatchStep = exports.getInitialState = exports.reducer = exports.name = void 0;

var _toolkit = require("@reduxjs/toolkit");

var _createBatchStep = require("./createBatchStep.constants");

var initialState = {
  step: _createBatchStep.CreateBatchStep.FileUpload
};

var _createSlice = (0, _toolkit.createSlice)({
  name: 'createBatchStep',
  initialState,
  reducers: {
    setStep: function setStep(state, action) {
      return Object.assign(state, {
        step: action.payload
      });
    }
  }
}),
    name = _createSlice.name,
    reducer = _createSlice.reducer,
    setCreateBatchStep = _createSlice.actions.setStep,
    getInitialState = _createSlice.getInitialState;

exports.getInitialState = getInitialState;
exports.setCreateBatchStep = setCreateBatchStep;
exports.reducer = reducer;
exports.name = name;